module.exports = __webpack_public_path__ + "img/step3.b9328e42.png";